import type { IModule, ModuleContext } from '@punica/editor';
import { ModuleLifecycleState } from '@punica/editor';
import { MODULE_NAMES } from '@punica/editor';

/**
 * Shell Statusbar module.
 * Depends on: kernel.events
 */
export class StatusbarModule implements IModule {
  readonly name = MODULE_NAMES.SHELL.STATUSBAR;
  readonly version = '1.0.0';
  readonly dependencies: readonly string[] = [MODULE_NAMES.KERNEL.EVENTS];

  #state: ModuleLifecycleState = ModuleLifecycleState.CREATED;

  get state(): ModuleLifecycleState {
    return this.#state;
  }

  async bootstrap(context: ModuleContext): Promise<void> {
    const { punica, registry } = context;

    const eventsState = registry.getState(MODULE_NAMES.KERNEL.EVENTS);
    if (eventsState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error(
        'kernel.events must be bootstrapped before shell.statusbar'
      );
    }

    if (!punica.shell?.Statusbar?.manager) {
      throw new Error('Statusbar manager not available');
    }
  }

  async start(context: ModuleContext): Promise<void> {
    // Statusbar module is ready to use after bootstrap
  }
}
